import React, { memo, useEffect } from "react";
import WebRTCPlayer from "../Cameras/WebRTCPlayer";
import { useDispatch } from "react-redux";
import { playbackActions } from "../../redux/features/shared/playback";
import { RecordingVideo } from "../CentralizeRecording/RecordingVideo";

const MultiplaybackView = ({ playbackList, isCR, visibleMultiPlaybackView }) => {
  
  const dispatch = useDispatch();

  console.log("VBISSUE", playbackList);

  useEffect(() => {
    return () => {
      dispatch(playbackActions.resetPlaybackState());
    };
  }, []);

  return (
    <>
      <div className="mosaic-row" style={{ height: "calc(100vh - 265px)" }}>
        <div className={playbackList.length > 1 ? "camerafilter2x2" : " centralizedPlayback"}>
          {playbackList?.map((item) => (
            <>
            {
              !isCR ?  
              <WebRTCPlayer
                key={item.playbackURL}
                id={
                  item.ParentCameraID +
                  "0" +
                  (Math.floor(Math.random() * (1000 - 1 + 1)) + 1).toString()
                }
                url={item?.playbackURL}
                isEncode={item?.isTranscoded}
                item={item}
                upperDivCss="HeightChildDiv"
                videoCss="mosaic"
                // fullVideoCss="player-responsive-fullScreen"
                buttonCss="mosaicButtonsMainDiv"
                noStreamDivCss="HeightChildDiv"
                showName={true}
                // playback={true}

                // prePostDisplay={false}
                // liveButton={true}
                // isSinglePlayback={true}
                // videoExportDownload={() => onSubmitBtn()}
                // exportStartTime={() => exportStartTime()}
                // exportEndTime={() =>exportEndTime()}
                // secondsDiff={() =>differenceTimeSec()}
              />
            : 
            <>
            {
              visibleMultiPlaybackView && (
                <RecordingVideo key={item?.playbackURL?.length > 0 ? item?.playbackURL[0] : ''} playbackList={item} item={item} />
              )
            }
            </>
            }
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default memo(MultiplaybackView);
